// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Cnfv","footer":"ReportModalFilter_footer__c0HUB"};